var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import './BuildingsList.scss';
import appFeatures from 'effective-features!';

import _ from 'lodash';
import startAddBuildingWizardFlow from '../AddBuildingWizard/flow';

var BuildingsListCtrl = function () {
    function BuildingsListCtrl($inject, $state, $stateParams, $scope, gatewayParamConfig, ModalService, CPCoverablesService, $filter, StateUtils, $q) {
        var _this = this;

        _classCallCheck(this, BuildingsListCtrl);

        this.$scope = $scope;
        this.$injector = $inject;
        this.$state = $state;
        this.sharedPageNum = 0; // Initial page num
        this.pageSize = gatewayParamConfig.cpPropertiesPerPage;
        this.ModalService = ModalService;
        this.CPCoverablesService = CPCoverablesService;
        this.$filter = $filter;
        this.model = StateUtils.activeDataForState(true).model;
        this.$q = $q;
        this.jobID = this.model.quoteID ? this.model.quoteID.value : this.model.jobID.value;

        this.isUpdateSpreadsheetScenario = false;
        this.spreadsheetProcessorEnabled = appFeatures.spreadsheetprocessor && appFeatures.spreadsheetprocessor.enabled;
        this.spreadsheetProcessorResult = $stateParams.spreadsheetProcessorResult;
        this.showSpreadsheetProcessorWizard = false;
        this.showSpreadsheetWizardStartButton = this.spreadsheetProcessorEnabled && !this.spreadsheetProcessorResult && !this.showSpreadsheetProcessorWizard;

        if (this.spreadsheetProcessorResult) {
            $stateParams.spreadsheetProcessorResult = undefined;
        }

        this.existingLocations = this.model.lobData.commercialProperty.coverables.locations;

        this.allBuildings = _(this.existingLocations.value).map(function (loc) {
            var address = loc.displayName;
            return loc.buildings.map(function (building) {
                return {
                    publicID: building.publicID,
                    classCode: building.classCode.code,
                    description: building.description || building.name, // Name is always present at least as autogenerated 'Bulding #N'
                    location: loc,
                    address: address,
                    isNewlyAdded: _this.buildingIsNewAddition(building.publicID) || false,

                    // Two params necessary to show menu when open no matter if item is hovered
                    hovered: false,
                    extraMenuOpen: false
                };
            });
        }).flatten().sortBy('publicID') // Assumption is that public id grows
        .sortBy(function (location) {
            return location.isNewlyAdded;
        }).reverse().valueOf();

        // Set up initial views
        this.filteredBuildings = this.allBuildings;
        this.shownBuildings = this.filteredBuildings;

        this.updateFilterState = this.updateFilterState.bind(this); // Without bind context is lost when function is passed via '<'
        this.next = this.next.bind(this);
        this.spreadsheetProcessor = this.spreadsheetProcessor.bind(this);
        this.manualAddBuilding = this.manualAddBuilding.bind(this);
    }

    _createClass(BuildingsListCtrl, [{
        key: 'buildingIsNewAddition',
        value: function buildingIsNewAddition(buildingPID) {
            if (this.model.newlyAddedBuildingList) {
                return _.contains(this.model.newlyAddedBuildingList, buildingPID);
            }
            return false;
        }
    }, {
        key: 'next',
        value: function next(nextTo) {
            var _this2 = this;

            this._removeLocationsWithoutBuildings().then(function () {
                nextTo(_this2.model);
            });
        }
    }, {
        key: '_removeLocationsWithoutBuildings',
        value: function _removeLocationsWithoutBuildings() {
            var _this3 = this;

            var REMOVE = true;
            var UPDATE = false;

            var getLocations = function getLocations() {
                return _this3.model.lobData.commercialProperty.coverables.locations.value;
            };

            var findLocationsWithoutBuildings = function findLocationsWithoutBuildings() {
                return getLocations().filter(function (loc) {
                    return loc.buildings.length === 0;
                });
            };

            var changePrimaryLocation = function changePrimaryLocation(location, sessionID) {
                if (location.isPrimary) {
                    // set any other location as location as primary
                    var newPrimaryLocation = getLocations().find(function (loc) {
                        return loc.publicID !== location.publicID;
                    });
                    newPrimaryLocation.isPrimary = true;

                    return _this3.CPCoverablesService.updateCPLocation(_this3.jobID, newPrimaryLocation, sessionID).then(function (updatedLocation) {
                        updateOrRemoveLocationFromSubmission(updatedLocation, UPDATE);
                    });
                }
                return _this3.$q.resolve();
            };

            var updateOrRemoveLocationFromSubmission = function updateOrRemoveLocationFromSubmission(location, remove) {
                var locations = _this3.model.lobData.commercialProperty.coverables.locations.value;
                var locationIndex = locations.findIndex(function (loc) {
                    return loc.publicID === location.publicID;
                });
                if (remove) {
                    locations.splice(locationIndex, 1);
                } else {
                    locations.splice(locationIndex, 1, location);
                }
            };

            var removeLocation = function removeLocation(promises, location) {
                var deferred = _this3.$q.defer();
                var sessionID = SessionUtil.getSessionUUID(_this3.model);

                changePrimaryLocation(location, sessionID).then(function () {
                    _this3.CPCoverablesService.removeCPLocation(_this3.jobID, location, sessionID).then(function () {
                        updateOrRemoveLocationFromSubmission(location, REMOVE);
                        deferred.resolve();
                    });
                });

                promises.push(deferred.promise);
                return promises;
            };

            var locationsRemoved = [];
            findLocationsWithoutBuildings().reduce(removeLocation, locationsRemoved);
            return this.$q.all(locationsRemoved);
        }
    }, {
        key: 'manualAddBuilding',
        value: function manualAddBuilding() {
            startAddBuildingWizardFlow(this.$injector);
        }
    }, {
        key: 'spreadsheetProcessor',
        value: function spreadsheetProcessor(isUpdateSpreadsheetScenario) {
            this.isUpdateSpreadsheetScenario = isUpdateSpreadsheetScenario;
            this.showSpreadsheetProcessorWizard = !this.showSpreadsheetProcessorWizard;
            this.showSpreadsheetWizardStartButton = false;
        }
    }, {
        key: 'updateFilterState',
        value: function updateFilterState(queriedData, filterApplicable, query) {
            this.filteredBuildings = queriedData;
            this.query = filterApplicable ? query : '';
            this.reset = !this.reset; // CPUI: This forces pagination to trigger. Weeeeeird. Shouldn't it watch incoming data?
        }
    }, {
        key: 'onPagination',
        value: function onPagination(pageData, pageNum) {
            this.shownBuildings = pageData.items;
            this.sharedPageNum = pageNum;
        }
    }, {
        key: 'addBuilding',
        value: function addBuilding(location) {
            startAddBuildingWizardFlow(this.$injector, { selectedLocation: location });
        }
    }, {
        key: 'showBuilding',
        value: function showBuilding(buildingId) {
            this.$state.go('cpBuildingWizardViewBuilding', {
                publicID: buildingId
            });
        }
    }, {
        key: 'showLocation',
        value: function showLocation(locationId) {
            this.$state.go('cpBuildingWizardViewLocation', {
                publicID: locationId
            });
        }
    }, {
        key: '_removeBuilding',
        value: function _removeBuilding(buildingID, location) {
            _.remove(location.buildings, function (building) {
                return building.publicID === buildingID;
            });
            _.remove(this.allBuildings, function (building) {
                return building.publicID === buildingID;
            });
        }
    }, {
        key: 'deleteBuilding',
        value: function deleteBuilding(locationID, buildingID) {
            var _this4 = this;

            var locations = this.model.lobData.commercialProperty.coverables.locations.value;
            var sessionID = SessionUtil.getSessionUUID(this.model);

            this.ModalService.showWarning('quoteandbind.cp.views.cp-building-view.Delete Building', 'quoteandbind.cp.views.cp-building-view.Are you sure you want to delete this building?', null, this.$filter('translate')('quoteandbind.cp.views.cp-building-view.Yes, please delete'), null, this.$filter('translate')('quoteandbind.cp.views.cp-building-view.No, Ill keep it')).result.then(function () {
                var loc = _.find(locations, function (location) {
                    return location.publicID === locationID;
                });
                var promise = void 0;
                var removeLocation = loc.buildings.length === 1 && !loc.isPrimary;
                if (removeLocation) {
                    promise = _this4.CPCoverablesService.removeCPLocation(_this4.jobID, loc, sessionID);
                } else {
                    promise = _this4.CPCoverablesService.removeCPBuilding(_this4.jobID, locationID, buildingID, sessionID);
                }
                _this4._handleDeleteBuildingState(promise, buildingID, removeLocation, loc, locations);
            });
        }
    }, {
        key: '_handleDeleteBuildingState',
        value: function _handleDeleteBuildingState(deletePromise, buildingID, removeLocation, location, locations) {
            var _this5 = this;

            deletePromise.then(function () {
                if (removeLocation) {
                    _.remove(locations, function (currLocation) {
                        return currLocation.publicID === location.publicID;
                    });
                }
                _this5._removeBuilding(buildingID, location);
            }).then(function () {
                _this5.reset = !_this5.reset;
            }).then(function () {
                if (locations.every(function (loc) {
                    return loc.buildings.length === 0;
                })) {
                    _this5.$state.go('cpBuildingWizardInitialScreen', { spreadsheetProcessorResult: null });
                }
            }).catch(function () {
                return _this5.ModalService.showError('quoteandbind.cp.directives.cp-building-view.Building not removed', 'quoteandbind.cp.views.cp-building-view.Please check for errors and try again');
            });
        }
    }, {
        key: 'mousein',
        value: function mousein(item) {
            /* eslint class-methods-use-this: 0 */
            item.hovered = true;
        }
    }, {
        key: 'mouseout',
        value: function mouseout(item) {
            /* eslint class-methods-use-this: 0 */
            item.hovered = false;
        }
    }, {
        key: 'ellipsisClosed',
        value: function ellipsisClosed(item) {
            item.extraMenuOpen = false;
            this.$scope.$applyAsync();
        }
    }, {
        key: 'ellipsisOpen',
        value: function ellipsisOpen(item) {
            item.extraMenuOpen = true;
            this.$scope.$applyAsync();
        }
    }]);

    return BuildingsListCtrl;
}();

BuildingsListCtrl.$inject = ['$injector', '$state', '$stateParams', '$scope', 'gatewayParamConfig', 'ModalService', 'qnb.cpCoverablesService', '$filter', 'StateUtils', '$q'];

export default BuildingsListCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/BuildingsList/BuildingsListCtrl.js
// module id = 986
// module chunks = 0